import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
//
import CarSection from '../components/CarSection';
import FindUs from '../components/FindUs';
import FooterContent from '../components/FooterContent';
import Hero from '../components/Hero';
import DownloadApp from '../components/ui/DownloadApp';
import Layout from '../layout/Layout';

import BlogSection from '../components/BlogSection';
import CalculateLoanSection from '../components/CalculateLoanSection';
import { CustomerAssurance } from '../components/CustomerAssurance';
import CustomerReviewSection from '../components/CustomerReviewSection';
import MatchBudgetSection from '../components/MatchBudgetSection';
import MediaRecognitionSection from '../components/MediaRecognitionSection';
import NeedHelp from '../components/NeedHelp';
import SearchByBodyType from '../components/SearchByBodyType';
import SearchByBrands from '../components/SearchByBrands';
import SellMyCarSection from '../components/SellMyCarSection';
import TradeSecSection from '../components/TradeSecSection';
import HelloPeterWidget from '../components/ui/HelloPeterWidget';
import WhatsAppBanner from '../components/WhatsAppBanner';
import { COUNTRY_TOP_LEVEL_DOMAIN } from '../constants';
import { getCarBodyTypes, getCars } from '../redux/actions/carActions';
import {
    resetNewCarsList,
    resetRecentCarsList,
    setNewCarListPage,
    setRecentCarListPage
} from '../redux/actions/carListAction';
import { getCustomerGallery } from '../redux/actions/customerGalleryActions';
import { fetchComingCars } from '../redux/actions/fetchComingCars';
import { fetchFeaturedCars } from '../redux/actions/fetchFeaturedCars';
import {
    fetchCheapestCarList,
    fetchNewCarList
} from '../redux/actions/fetchNewCarListAction';
import { ICombineReducerType } from '../redux/reducers';
import { getMaxPriceAccToCountry, SetMeta } from '../utils/Helper/jsHelpers';
import { getTopLevelDomain } from '../utils/translation';

export const CAR_LIST_TYPE_ENUM = {
    electricCars: 'electricCars',
    importedCars: 'importedCars',
    newCars: 'newCars',
    cheapestCars: 'cheapestCars',
    fuelAndBodyType: 'fuelAndBodyType',
    custom: 'custom',
    incomingCars: 'incomingCars',
    voetstootsTradeSaleCars: 'voetstootsTradeSaleCars'
} as const;

export type ICarListType = keyof typeof CAR_LIST_TYPE_ENUM;

const Home = () => {
    const dispatch = useDispatch();
    const { featuredCars } = useSelector(
        (state: ICombineReducerType) => state.featuredCars
    );
    const { cars: recentlyAdded } = useSelector(
        (state: ICombineReducerType) => state.car
    );
    const { incomingCars } = useSelector(
        (state: ICombineReducerType) => state.incomingCars
    );
    const topLevelDomain = getTopLevelDomain();
    const isCarAmigo =
        topLevelDomain === COUNTRY_TOP_LEVEL_DOMAIN.sn ||
        topLevelDomain === COUNTRY_TOP_LEVEL_DOMAIN.asterdio;
    useEffect(() => {
        // (async function () {
        getCars(dispatch, { page: 1, limit: 8 });
        getCustomerGallery(dispatch);
        fetchNewCarList(dispatch, { page: 1, limit: 6 });
        fetchFeaturedCars(dispatch, { page: 1, limit: 6 });
        fetchCheapestCarList(
            dispatch,
            getMaxPriceAccToCountry(topLevelDomain),
            {
                page: 1,
                limit: 3,
                random: true
            }
        );
        fetchComingCars(dispatch, { page: 1, limit: 6 });
        // Increase recently and new car listing page number by one
        setNewCarListPage(dispatch, 2);
        setRecentCarListPage(dispatch, 2);

        getCarBodyTypes(dispatch, true);
        // })();

        return () => {
            resetNewCarsList(dispatch);
            resetRecentCarsList(dispatch);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const location = useLocation();
    useEffect(() => {
        const hash = location.hash;

        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element?.id !== 'find-us') return;
            element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [location]);

    return (
        <>
            <SetMeta
                title="homePageTitle"
                desc="homePageDesc"
                keywords="homePageKeywords"
            />
            <div className="home">
                <Layout>
                    <Hero recentlyAddedCars={recentlyAdded} />
                    <CustomerAssurance />
                    {/* Featured Cars */}
                    <CarSection
                        sectionTitle="featuredCars"
                        carData={featuredCars.cars}
                        additionalSectionClass="transparent-green"
                    />
                    <SearchByBodyType />

                    {isCarAmigo && (
                        <CarSection
                            sectionTitle="buyComingCars"
                            carData={incomingCars.cars}
                            type="incomingCars"
                            additionalSectionClass=""
                        />
                    )}

                    <SearchByBrands />
                    <TradeSecSection />
                    <CarSection
                        sectionTitle="recentlyAdded"
                        carData={recentlyAdded.cars}
                        additionalSectionClass=""
                    />
                    <div className="section-main-container bg-white">
                        <CalculateLoanSection />
                    </div>
                    <MatchBudgetSection />
                    <div className="bg-white">
                        {topLevelDomain === COUNTRY_TOP_LEVEL_DOMAIN.coza ? (
                            <HelloPeterWidget />
                        ) : (
                            <CustomerReviewSection />
                        )}
                    </div>
                    <SellMyCarSection />
                    <BlogSection />
                    <div className="bg-white">
                        <MediaRecognitionSection />
                    </div>
                    <FindUs />
                    <div className="bg-white">
                        <FooterContent />
                    </div>
                    <div className="bg-white">
                        <NeedHelp />
                    </div>
                    <WhatsAppBanner />
                    <DownloadApp />
                </Layout>
            </div>
        </>
    );
};

export default Home;
